import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";

import api from "../../components/commonComponents/axiosSetup";
import { BASE_URL } from "../../config";

// const BASE_URL = "http://192.168.60.226";




// import api from "./axiosSetup";

// export const fetchAccounts = createAsyncThunk(
//   'customerManagement/fetchAccounts',
//   async (_, thunkAPI) => {
//     try {
//       const response = await api.get('${BASE_URL}api/v1/account/all');
//       return response.data.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch accounts');
//     }
//   }
// );
export const fetchAccounts = createAsyncThunk(
  'customerManagement/fetchAccounts',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/v4/account/all`);
      console.log(response)
      return response.data.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch accounts');
    }
  }
);




export const createAccounts = createAsyncThunk(
  'customerManagement/createAccounts', 
  async (accountData, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}api/v4/account/create`,
        accountData
      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchAccounts());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);
export const updateAccounts = createAsyncThunk(
  'customerManagement/updateAccounts', 
  async (accountData, thunkAPI) => {
    try {
      const response = await api.put(`${BASE_URL}api/v4/account/update`,
        accountData

      );
      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchAccounts());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Account'
      );
    }
  }
);

export const updateAccountsState = createAsyncThunk(
  'customerManagement/updateAccountsState', 
  async (accountData, thunkAPI) => {
    try {
      const response = await api.patch(`${BASE_URL}api/v4/account/deactivate?accountId=${accountData.accountId}&status=${accountData.status}`

      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchAccounts());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Account'
      );
    }
  }
);
export const deleteAccount = createAsyncThunk(
  'customerManagement/deleteAccount',
  async (companyId, thunkAPI) => {
    try {
      await api.delete(`${BASE_URL}api/v1/account/delete?companyId=${companyId}`);

      // Refresh account list after deletion
      thunkAPI.dispatch(fetchAccounts());

      return companyId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete account');
    }
  }
);

export const fetchAccountsName = createAsyncThunk(
  'customerManagement/fetchAccountsName',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/v4/account/all-accountsName`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch account Name');
    }
  }
);
export const fetchAccountUser = createAsyncThunk(
  'customerManagement/fetchAccountUser',
  async (accountName, thunkAPI) => {
    try {
      const response = await api.get(`http://192.168.40.227:8081/api/v1/users/getUserByCompanyName?accountName=${accountName}`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch accounts');
    }
  }
);
export const fetchusers = createAsyncThunk(
  'customerManagement/fetcUsers',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/v1/users/all`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch User');
    }
  }
);

export const fetchUSERName = createAsyncThunk(
  'customerManagement/fetchUSERName',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}User/getallnames`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch UserName');
    }
  }
);

export const createUser = createAsyncThunk(
  'customerManagement/createUser', 
  async (userdata, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}api/v1/users/create`,
        userdata
      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchusers());
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);

export const updateUser = createAsyncThunk(
  'customerManagement/updateAccountss', 
  async (updateUser, thunkAPI) => {
    try {
      const response = await api.put(`${BASE_URL}api/v1/users/update`,
        updateUser

      );
      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchusers());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Account'
      );
    }
  }
);

export const deleteUser = createAsyncThunk(
  'customerManagement/deleteUser',
  async (userId, thunkAPI) => {
    try {
      await api.delete(`${BASE_URL}api/v1/users/delete?id=${userId}`);

      // Refresh account list after deletion
      thunkAPI.dispatch(fetchusers());

      return userId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete account');
    }
  }
);

export const fetchRoles  = createAsyncThunk('customerManagement/fetchRoles', async(_, thunkApi)=>{
  const rolesData = [
      {
        id:1,
        role_name: "DJB_VALIDATION_ADMIN",
        account: "DJB_Validation_Account",
        description: "DJB_VALIDATION_ADMIN",
        creation_date: "03 Feb 2021 15:42:44",
      },
      {
        id:2,
        role_name: "DJB_VALIDATE_ADMIN",
        account: "DJB_Validation_Account",
        description: "DJB_VALIDATE_ADMIN",
        creation_date: "03 Feb 2021 15:42:44",
      },
      {
        id:3,
        role_name: "QA_VIEW_ROLE",
        account: "QA",
        group: "",
        description: "QA_VIEW_ROLE_view",
        creation_date: "11 Jan 2021 18:35:18",
      },
      {
        id: 4,
        role_name: "DJB_QA_ADMIN",
        account: "PREPAID_ESM",
        description: "DJB_QA_ADMIN_user",
        creation_date: "11 Jan 2021 18:29:36",
      },
    ];


    return new Promise((resolve)=>{
      setTimeout(()=>{
        resolve(rolesData)
      }, 500)
    })

})


export const fetchAPIUSER = createAsyncThunk(
  'customerManagement/fetchApiUser',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/v1/get_api_user`);
      console.log(response)
      return response.data.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch User');
    }
  }
);

export const fetchAPIUSERName = createAsyncThunk(
  'customerManagement/fetchAPIUSERName',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}apiUser/getallnames`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch UserName');
    }
  }
);

export const createAPIUser = createAsyncThunk(
  'customerManagement/createAPIUser', 
  async (APIUSERDATA, thunkAPI) => {
    try {
      console.log("Sending API User:", APIUSERDATA);
      const response = await api.post(
        `${BASE_URL}api/v1/create_User_Api`,
        APIUSERDATA
      );
      console.log("API Response:", response);
      thunkAPI.dispatch(fetchAPIUSER());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);

export const deleteAPIUser = createAsyncThunk(
  'customerManagement/deleteAPIUser',
  async (userId, thunkAPI) => {
    console.log(userId, "testID")
    try {
      await api.delete(`${BASE_URL}api/v1/deleteuser/${userId}`);

      // Refresh account list after deletion
      thunkAPI.dispatch(fetchAPIUSER());

      return userId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete account');
    }
  }
);

export const updateAPIUser = createAsyncThunk(
  'customerManagement/updateAPIUser', 
  async ( userData , thunkAPI) => {
    try {
      // console.log("Updating API User:", id, userData);
      const response = await api.put(
        `${BASE_URL}api/v1/update`,
        userData
      );
      console.log("Update API Response:", response);
      thunkAPI.dispatch(fetchAPIUSER());
      return response.data;
    } catch (error) {
      console.error("Update API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to update API User'
      );
    }
  }

);



export const createRoleAccess = createAsyncThunk(
  'customerManagement/createRoleAccess', 
  async (RoleAccessdata, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}sim-auth/createRole`,
        RoleAccessdata
      );
      console.log("API Response:", response);
      thunkAPI.dispatch(fetchRoleAccess());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);


export const fetchRoleAccess = createAsyncThunk(
  'customerManagement/fetchRoleAccess',
  async ( _, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}sim-auth/all?pageSize=10&pageNo=0`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch User');
    }
  }
);
export const fetchRoleAccessName = createAsyncThunk(
  'customerManagement/fetchRoleAccessName',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}sim-auth/assign-roles`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch account Name');
    }
  }
);
export const updateRoleAccess = createAsyncThunk(
  'customerManagement/updateRoleAccess', 
  async (updateData, thunkAPI) => {
    try {
      const response = await api.put(`${BASE_URL}sim-auth/update`,
        updateData

      );
      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchRoleAccess());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Account'
      );
    }
  }
);



//create API Endpoints for assigning later
export const createAPIPermission = createAsyncThunk(
  'customerManagement/createAPIPermission', 
  async (APIDATA, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}api/userApi/permission?companyId=12`,
        APIDATA
      );
      console.log("API Response:", response);
      thunkAPI.dispatch(fetchAPIPermissions());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);

export const fetchAPIPermissions = createAsyncThunk(
  'customerManagement/fetchAPIPermissions',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/userApi/allpermission`);
      // console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch User');
    }
  }
);

export const updateAPIPermission = createAsyncThunk(
  'customerManagement/updateAPIPermission', 
  async ({ updateData, id }, thunkAPI) => {
    try {
      const response = await api.put(
        `${BASE_URL}api/userApi/updatepermission/${id}`,
        updateData
      );

      thunkAPI.dispatch(fetchAPIPermissions());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Permission'
      );
    }
  }
);


export const deleteAPIPermissions = createAsyncThunk(
  'customerManagement/deleteAPIPermissions',
  async (id, thunkAPI) => {
    try {
      await api.delete(`${BASE_URL}api/userApi/deletepermission?id=${id}`);

      // Refresh account list after deletion
      thunkAPI.dispatch(fetchAPIPermissions());

      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete account');
    }
  }
);

// Create API Role And Access
export const createAPIRoleACCess = createAsyncThunk(
  'customerManagement/createAPIRoleACCess', 
  async (APIRoleData, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}apiUser/AssignedApis`,
        APIRoleData
      );
      console.log("API Response:", response);
      // thunkAPI.dispatch(fetchAPIPermissions());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);

//fetch api Role and Access by id or name 
export const fetchAPIRoleAccess = createAsyncThunk(
  'customerManagement/fetchAPIRoleAccess',
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}apiUser/AssignedApisbyId/${id}`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch UserName');
    }
  }
);


export const fetchAllAPIRoleAccess = createAsyncThunk(
  'customerManagement/fetchAllAPIRoleAccess',
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}api/userApi/category`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch UserName');
    }
  }
);
export const updateAPIRoleAccess = createAsyncThunk(
  'customerManagement/updateAPIRoleAccess', 
  async (APIRoleData, thunkAPI) => {
    try {
      const response = await api.put(
        `${BASE_URL}apiUser/UpdateAssignedApis/byName/${APIRoleData.assignedTo}`,
        APIRoleData
      );
      console.log("API Response:", response);
      // thunkAPI.dispatch(fetchAPIPermissions());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);

export const fetchAPIPERMISSION  = createAsyncThunk('customerManagement/fetchApiPermission', async(_, thunkApi)=>{
const apiUsersData = [
  {
    id: 1,
    apiName: "User Management API",
    apiKey: "api_key_user_mgmt_12345",
    endpoint: "/api/v1/users",
    method: " DELETE",
    status: "Active",
    category:"User Management",
    createdDate: "10 Jan 2021 14:30:00",
    lastUsed: "16 Jul 2025 09:15:30",
    description: "API for managing user accounts and profiles",
  },
  {
    id: 2,
    apiName: "Account Management API",
    apiKey: "api_key_account_mgmt_67890",
    endpoint: "/api/v1/accounts",
    method: "GET",
    category:"Account Management",
    status: "Active",
    createdDate: "15 Jan 2021 11:45:00",
    lastUsed: "16 Jul 2025 08:22:15",
    description: "API for account creation and management",
  },
  {
    id: 3,
    apiName: "Reports API",
    apiKey: "api_key_reports_54321",
    endpoint: "/api/v1/reports",
    method: "GET",
    category:"Report Management",
    status: "Inactive",
    createdDate: "20 Jan 2021 16:20:00",
    lastUsed: "10 Jul 2025 12:30:45",
    description: "API for generating and retrieving reports",
  },
  {
    id: 4,
    apiName: "Data Plan API",
    apiKey: "api_key_dataplan_98765",
    endpoint: "/api/v1/dataplans",
    method: " POST",
    status: "Active",
    category:"Data Management",
    createdDate: "25 Jan 2021 10:15:00",
    lastUsed: "16 Jul 2025 07:45:20",
    description: "API for data plan management and configuration",
  },
]


    return new Promise((resolve)=>{
      setTimeout(()=>{
        resolve(apiUsersData)
      }, 500)
    })

})



